export default __webpack_public_path__ + "static/media/book3.202bbb66.pdf";